import { useEffect, useRef } from "react";
import { useWellness } from "@/context/WellnessContext";
import { buildWellnessSummary } from "@/utils/analytics/studentAggregation";
import { trackAggregatedStudentSummary } from "@/utils/analytics";
import { isStudentUser } from "@/utils/analytics/consent";
import { useBootstrap } from "../features/bootstrap";

export function useStudentAnalyticsAggregation() {
  const { data: user } = useBootstrap();
  const { getAllRaw, loadedPeriods } = useWellness();
  const lastSummaryKeyRef = useRef(null);

  useEffect(() => {
    if (!user || isStudentUser(user)) {
      return;
    }
    if (!user?.studentIds?.length) {
      return;
    }

    const wellnessRecords = getAllRaw();
    if (!Array.isArray(wellnessRecords) || wellnessRecords.length === 0) {
      return;
    }

    const summary = buildWellnessSummary(wellnessRecords, { role: user.role });
    if (!summary) return;

    const key = `${summary.metrics.total}-${summary.metrics.helpfulCounts?.true ?? 0}-${summary.metrics.helpfulCounts?.false ?? 0}`;
    if (key === lastSummaryKeyRef.current) {
      return;
    }
    lastSummaryKeyRef.current = key;
    trackAggregatedStudentSummary(summary, user);
  }, [user, getAllRaw, Object.keys(loadedPeriods || {}).length]);
}
